import { Button, SxProps, TypographyProps } from "@mui/material";
import { ReactComponent as OpenLinkInNewTabIcon } from "../../../../../../common/icons/open-in-new-tab-icon.svg";
import NewTabLink from "../../../../../../common/components/functional/links/NewTabLink";
import { routes } from "../../../../../../app/paths";

type Props = {
  id: string;
  talentName: string;
  buttonSx?: SxProps;
  TypographyProps?: TypographyProps;
  withIcon?: boolean;
};

const TalentProfileLinkButton = ({
  id,
  talentName,
  buttonSx = {},
  TypographyProps = {},
  withIcon = true,
}: Props) => (
  <Button
    sx={{ fontSize: "23px", fontWeight: 500, ...buttonSx }}
    endIcon={withIcon ? <OpenLinkInNewTabIcon /> : null}
  >
    <NewTabLink
      to={routes.talentProfile(id)}
      text={talentName}
      TypographyProps={TypographyProps}
    />
  </Button>
);

export default TalentProfileLinkButton;
